const DEFAULT_ERROR_MESSAGE = "Something went wrong. Please try again.";

const nonEmptyString = (value) => (typeof value === "string" && value.trim().length > 0 ? value.trim() : null);

const normalizeMessage = (value) => {
  const raw = nonEmptyString(value);
  if (!raw) return null;

  const sanitized = raw
    .replace(/^OnResponseError:\s*/i, "")
    .replace(/^AxiosError:\s*/i, "")
    .replace(/^Error:\s*/i, "")
    .replace(/^Request failed with status code \d+\s*:\s*/i, "")
    .replace(/^Request failed with status code \d+\s*/i, "")
    .replace(/\s*\[object Object\]\s*/gi, " ")
    .trim();

  return sanitized.length > 0 ? sanitized : null;
};

const parseResponseDataMessage = (data) => {
  if (!data) return null;

  const direct = normalizeMessage(data);
  if (direct) return direct;

  const message = normalizeMessage(data.message);
  if (message) return message;

  const detail = normalizeMessage(data.detail);
  if (detail) return detail;

  const errorText = normalizeMessage(data.error);
  if (errorText) return errorText;

  if (data.error && typeof data.error === "object") {
    const nestedMessage = normalizeMessage(data.error.message);
    if (nestedMessage) return nestedMessage;
  }

  if (Array.isArray(data.errors)) {
    const firstError = data.errors[0];
    const arrayMessage = normalizeMessage(firstError?.message) || normalizeMessage(firstError);
    if (arrayMessage) return arrayMessage;
  }

  return null;
};

const parseError = (error) => {
  if (!error) return DEFAULT_ERROR_MESSAGE;

  console.error("parsing error message: ", error);

  if (typeof error === "string") return normalizeMessage(error) || error;

  if (error.response) {
    const responseMessage = parseResponseDataMessage(error.response.data);
    if (responseMessage) return responseMessage;
  }

  if (error.error) {
    return parseError(error.error);
  }

  const message = normalizeMessage(error.message);
  if (message) return message;

  return DEFAULT_ERROR_MESSAGE;
};

module.exports = {
  parseError,
};
